export function findParent<T extends HTMLElement>(item: HTMLElement, predicate: (item: T) => boolean): T | undefined {
    let current = item.parentElement;
    do {
        if (!(current instanceof HTMLElement)) {
            return undefined;
        }
        if (predicate(current as T)) {
            return current as T;
        }
        current = current.parentElement;
    }
    while (true);
}
